<template>
  <div>
    <modals-container name="modal1" />
    <v-dialog/>
    <div class="class_add_top">
      <a class="back" onclick="history.go(-1)">返回</a>
      菜单<span v-if="isEdit">编辑</span><span v-if="!isEdit">新增</span>
    </div>
    <form class="class_add_con w622 col_2_1 " data-vv-scope="form" style="width: 944px;">
      <table width="100%" border="0" cellspacing="0" cellpadding="0" class="page_edit_table">
        <tr class="tita">
          <td colspan="2" align="left" class="left_td" style="text-align:left;">菜单基本信息</td>
        </tr>
        <tr>
          <td align="center"  class="t_left3">上级菜单：</td>
          <td><input type="text" class="search_put" v-model="form.parent.name" @click="show1" disabled="disabled" /><input name="" type="button" class="search_btn" @click="show1" /></td>
        </tr>
        <!--input type="text" v-model="searchword" />
        <button type="button" @click="search">GO</button-->
        <tr>
          <td align="center"  class="t_left3">名称：</td>
          <td>
            <input name="name" type="text" class="put_txt w280" v-model="form.name" v-validate="'required'" />
            <span>*</span>
            <span style="color: #ff3633;">{{ errors.first('form.name') }}</span>
          </td>
        </tr>
        <tr>
          <td align="center"  class="t_left3">链接：</td>
          <td><input name="" type="text" class="put_txt w460" v-model="form.href" /><i>点击菜单跳转的页面</i></td>
        </tr>
        <!--tr>
          <td align="center"  class="t_left3">目标：</td>
          <td><input name="" type="text" class="put_txt w100" value="manFrame"/><i>链接地址打开的目标窗口，默认：manFrame</i></td>
        </tr-->
        <tr>
          <td align="center"  class="t_left3">排序：</td>
          <td>
            <input name="sort" type="text" class="put_txt w100" v-model="form.sort" v-validate="'required'" />
            <span>*</span>
            <span style="color: #ff3633;">{{ errors.first('form.sort') }}</span>
          </td>
        </tr>
        <tr>
          <td align="center"  class="t_left3">可见：</td>
          <td><input type="radio" value="1" v-model="form.isShow" /> 可见　<input type="radio" value="0" v-model="form.isShow" /> 隐藏　<i>该菜单是否显示到系统菜单中</i></td>
        </tr>
        <tr>
          <td align="center"  class="t_left3">是否登录：</td>
          <td><input type="radio" value="1" v-model="form.isAllow" /> 是　<input type="radio" value="0" v-model="form.isAllow" /> 否　<i>该接口是否需要登录</i></td>
        </tr>
        <tr>
          <td align="center"  class="t_left3">接口地址：</td>
          <td><input type="text" class="put_txt w350" v-model="form.permission" /></td>
        </tr>
        <!--tr>
          <td align="center" class="t_left3" >备注：</td>
          <td><textarea name="" cols="" rows="" class="text_area"></textarea></td>
        </tr-->
        <tr>
          <td class="t_left2">&nbsp;</td>
          <td align="left"  class="t_left2">
            <input name="" type="button" class="put_btn" value="确认提交" @click="validateForm('form')" />　
            <!--input name="" class="put_btn" type="button" value="重填" /-->
          </td>
        </tr>
      </table>
    </form>
    <div class="clear"></div>
  </div>
</template>

<script>
  import config from '@/config'
  import api from '@/api'
  import utils from '@/utils'
  import Bus from '@/utils/bus'
  import TreeSelect from '@/page/byl/sys/menu/treemenu.vue'
  export default {
    data () {
      return {
        form: {
          parent: {},
          isShow: '1',
          isAllow: '1'
        },
        oldParentId: '0',
        menus: [],
        prefix: this.$route.meta.prefix || ''
      }
    },
    created () {
      this.getMenus()
    },
    mounted () {
      if (this.isEdit && !this.hasParent) { // "正常编辑功能": 通过 id 取信息并且要给select赋值
        this.getModel(this.$route.params.id)
        this.$on('data-prepared', function (data) {
          this.form.parent = {
            id: data.parentId,
            parentIds: data.parentIds,
            name: data.parentName
          }
          this.oldParentId = (utils.deepCopy({}, this.form.parent).id)?utils.deepCopy({}, this.form.parent).id:'0'
        });
      }
      if (this.hasParent) { // "新增下级菜单功能": 通过 parentId 获取上位菜单信息
        if (this.$route.params.parentId == '0') {
          this.form.parent = {
            id: '0',
            parentIds: '0,',
            name: ''
          }
          this.oldParentId = '0'
        } else {
          this.getModel(this.$route.params.parentId, true)
          this.$on('data-prepared', function (data) {
            this.form.parent = {
              id: data.id,
              parentIds: data.parentIds,
              name: data.name
            }
            this.oldParentId = (utils.deepCopy({}, this.form.parent).id)?utils.deepCopy({}, this.form.parent).id:'0'
          });
        }
      }
      this.$on('menu-prepared', function (data) {
        this.menus = data
      });
      var that = this
      Bus.$on('selected-parent-menu', function (data) {
        if (that.form.parent) { delete that.form.parent }
        that.$set(that.form, 'parent', data[0]);
      })
    },
    computed: {
      isEdit () {
        return this.$route.params.id && this.$route.params.id !== 'void'
      },
      hasParent () {
        return this.$route.params.parentId && this.$route.params.parentId !== 'void'
      }
    },
    methods: {
      show1 () {
        var that = this
        this.$modal.show(TreeSelect, {
          data: that.menus
        })
      },
      popup (msg) {
        this.$toasted.show(msg)
      },
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: '提交',
          text: '确认提交吗？',
          buttons: [
            {
              title: '确认',
              default: true,
              handler: utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      validateForm (scope) {
        var bus = this
        var _dealParams = function () { // 处理发送给后台的数据结构
          if (bus.form.parent) {
            bus.form.parentId = (bus.form.parent.id) ? bus.form.parent.id : '0'
            // console.log(bus.oldParentId)
            if (bus.isEdit) {
              if (bus.hasParent) { // '新增下级菜单的情况'
                bus.form.parentIds = (bus.form.parent.parentIds) ? bus.form.parent.parentIds + bus.form.parentId + ',': '0,'
                // console.log(bus.form.parentIds)
              } else { // 普通编辑的情况
                if (bus.form.parent.id == bus.oldParentId) { // 上级菜单没有变化
                  if (bus.form.parent.parentIds == '0') {
                    bus.form.parent.parentIds = '0,'
                  }
                  bus.form.parentIds = (bus.form.parent.parentIds) ? bus.form.parent.parentIds: '0,'
                } else { // 上级菜单有变更需要将上位菜单的id加上
                  bus.form.parentIds = (bus.form.parent.parentIds) ? bus.form.parent.parentIds + ',' + bus.form.parentId + ',': '0,'
                }
                // console.log(bus.form.parentIds)
              }
            } else { // 新增的情况
              bus.form.parentIds = (bus.form.parent.parentIds) ? bus.form.parent.parentIds + ',' + bus.form.parentId + ',' : '0,'
            }
          }
        }
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            _dealParams()
            bus.confirmBox({
              yes: function () {
                delete bus.form.parent
                api.post(config.bylBaseCenterPath, '/menu/save', bus.form, function (r) { // 正常
                  if (bus.isEdit) { // 编辑
                    bus.popup('保存成功')
                  } else {
                    bus.popup('创建菜单成功')
                  }
                  bus.$router.push(bus.prefix +'/org/menuList')
                })
              }
            })
          } else {
            bus.popup('请确保信息正确与完整')
            return false
          }
        })
      },
      to (path) {
        this.$router.push(path)
      },
      getModel (id, noForm) {
        var that = this
        api.get(config.bylBaseCenterPath, '/menu/get', {id: id}, function (r) { // 正常
          if (!noForm) {
            that.form = r.data
            that.$emit('data-prepared', that.form)
          } else {
            that.$emit('data-prepared', r.data)
          }
        })
      },
      getMenus (filters) {
        if (!filters) { filters = {} }
        var that = this
        api.post(config.bylBaseCenterPath, '/menu/listByRole', null, function (r) { // 正常
          that.$emit('menu-prepared', r.data)
        })
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/byl/org/orgmenu/model.vue